// /* eslint-disable */
// import React from 'react';
// import { useHistory } from 'react-router-dom';
// import './DashboardSection.css';
// import NewInfoIcon from '../ProcureToPayComp/TileComp/NewInfoIcon';

// const DashboardSection = ({
//   title,
//   children,
//   showDetailView = true,
//   disableDetailView = false,
//   detailPath,
//   popupContent,
//   detailState = {} ,
//   showInfoIcon = true,
//   disableInfoIcon = false
// }) => {
//   const history = useHistory();

//   const handleDetailClick = () => {
//     if (detailPath) {
//       history.push(detailPath, detailState);
//     }
//   };

//     const titleStyle = {
//     color: "white",
//     fontSize: "0.72rem",
//     fontWeight: 500,
//     fontFamily: "Roboto",
//     lineHeight: "1.2",
//   };


//   return (
//     <div className="dashboard-section">
//       <div className="dashboard-section-header">
//         <h3>{title}</h3>
//         {showDetailView && !disableDetailView && (
//           <button
//             className="detail-view-btn"
//             onClick={handleDetailClick}
//           >
//             Detailed View <span className="arrow">»</span>
//           </button>
//         )}

//       {/* <div> */}
//       { showInfoIcon && !disableInfoIcon && (
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
//       <div style={titleStyle}>{title || "Metric Name"}</div>
//       <NewInfoIcon popupContent={popupContent} inlineMode={true} />
//     </div>
//       )}

//       {/* </div> */}
//       </div>
//       <div className="dashboard-section-body">
//         {children}
//       </div>
//     </div>
//   );
// };

// export default DashboardSection;

/* eslint-disable */
import React from "react";
import { useHistory } from "react-router-dom";
import "./DashboardSection.css";
import NewInfoIcon from "../ProcureToPayComp/TileComp/NewInfoIcon";

const DashboardSection = ({
  title,
  children,
  showDetailView = true,
  disableDetailView = false,
  detailPath,
  popupContent,
  detailState = {},
  showInfoIcon = true,
  disableInfoIcon = false,
}) => {
  const history = useHistory();

  const handleDetailClick = () => {
    if (detailPath) {
      history.push(detailPath, detailState);
    }
  };

  return (
    <div className="dashboard-sectionp2p">
      
      {/* HEADER */}
      <div className="dashboard-section-header">
        
        {/* LEFT SIDE - TITLE */}
        <h3 className="section-title">{title}</h3>

        {/* RIGHT SIDE - ACTIONS */}
        <div className="section-actions">
          
          {showInfoIcon && !disableInfoIcon && (
            <NewInfoIcon
              popupContent={popupContent}
              inlineMode={true}
            />
          )}

          {showDetailView && !disableDetailView && (
            <button
              className="detail-view-btn"
              onClick={handleDetailClick}
            >
              Detailed View <span className="arrow">»</span>
            </button>
          )}

        </div>
      </div>

      {/* BODY */}
      <div className="dashboard-section-body">
        {children}
      </div>
    </div>
  );
};

export default DashboardSection;
